import { Skeleton } from "../../../../components/ui/skeleton";

export const SugerenciaTableSkeleton = ({ rows = 5 }) => {
  return Array.from({ length: rows }).map((_, index) => (
    <tr key={index}>
      <td>
        <Skeleton height="20px" width="120px" />
      </td>

      <td>
        <Skeleton height="20px" width="70px" />
      </td>

      <td>
        <Skeleton height="20px" width="100px" />
      </td>

      <td>
        <Skeleton height="20px" width="100px" />
      </td>

      <td>
        <Skeleton height="20px" width="90px" />
      </td>

      <td>
        <Skeleton height="20px" width="50px" />
      </td>

      <td>
        <Skeleton height="20px" width="40px" />
      </td>
    </tr>
  ));
};
